import WideDrawer from "../../../../../../../components/general/WideDrawer.tsx";
import type {CustomerBankAccount} from "../../../../../../../api/customerBankAccounts/CustomerBankAccount.ts";
import type {TFICDocument} from "../../../../../../../views/DocumentDrawer/types/Document";
import type {CreditCardStatementDocumentOption, MissingDocumentRequest} from "../../types.ts";
import {CreditCardSettlementContent} from "./CreditCardSettlementContent.tsx";
import type {CreditCardSettlementFormPayload} from "./utils/creditCardSettlementUtils.ts";

interface CreditCardSettlementDrawerProps {
    isOpen: boolean;
    onClose: () => void;
    settlementTransaction: MissingDocumentRequest | null;
    documents: CreditCardStatementDocumentOption[];
    creditCardAccounts: CustomerBankAccount[];
    isLoading: boolean;
    previewDocument: TFICDocument | null;
    isPreviewLoading: boolean;
    isSubmitting: boolean;
    onSelectDocument: (documentId: string) => void;
    onSubmit: (payload: CreditCardSettlementFormPayload) => void;
}

export function CreditCardSettlementDrawer({
    isOpen,
    onClose,
    settlementTransaction,
    documents,
    creditCardAccounts,
    isLoading,
    previewDocument,
    isPreviewLoading,
    isSubmitting,
    onSelectDocument,
    onSubmit,
}: CreditCardSettlementDrawerProps) {
    return (
        <WideDrawer
            open={isOpen}
            updateOpenState={(open) => {
                if (!open) {
                    onClose();
                }
            }}
            title="Creditcard invullen"
            width="xl"
        >
            {isOpen && settlementTransaction ? (
                <CreditCardSettlementContent
                    key={settlementTransaction.transaction_id}
                    settlementTransaction={settlementTransaction}
                    documents={documents}
                    creditCardAccounts={creditCardAccounts}
                    isLoading={isLoading}
                    previewDocument={previewDocument}
                    isPreviewLoading={isPreviewLoading}
                    isSubmitting={isSubmitting}
                    onSelectDocument={onSelectDocument}
                    onSubmit={onSubmit}
                />
            ) : null}
        </WideDrawer>
    );
}
